package app.nestbridge.feature.main.ui

import app.nestbridge.feature.main.screen.MainShellScreen
import app.nestbridge.feature.main.screen.MainShellState
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.screen.Screen
import com.slack.circuit.runtime.ui.Ui
import com.slack.circuit.runtime.ui.ui
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
public class MainShellUiFactory : Ui.Factory {
  override fun create(screen: Screen, context: CircuitContext): Ui<*>? = when (screen) {
    MainShellScreen -> ui<MainShellState> { state, modifier -> MainShellUi(state = state, modifier = modifier) }
    else -> null
  }
}
